import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { FlightRulesLegendComponent } from './flight-rules-legend/flight-rules-legend.component';
import { FlightRulesSvgComponent } from './flight-rules-legend/flight-rules-svg/flight-rules-legend-svg';

export const FLIGHT_RULES_LEGEND: TwcLegendParams = {
  title: 'FLIGHT CONDITIONS',
  legendTitleBarInfo: signal('0'),
  data: {
    svgComponent: FlightRulesSvgComponent,
    pluginIDs: ['ifr', 'mvfr', 'lifr']
  },
  legendComponent: FlightRulesLegendComponent
};
